import { Component, Input, Self, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TextInputComponent implements ControlValueAccessor {
  @Input() placeholder: string;
  @Input() type: string;
  @Input() icon: string;
  @Input() label: string;
  @Input() uppercase: boolean = false;

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  onInput(event: any): void {
    if (this.uppercase) {
      const value = event.target.value.toUpperCase().replace(/\s/g, '');
      this.ngControl?.control?.setValue(value);
    }
  }

  writeValue(obj: any): void { }

  registerOnChange(fn: any): void { }

  registerOnTouched(fn: any): void { }
}
